import { combineReducers } from '@reduxjs/toolkit';
import pagesSlice from './pages/pagesSlice';
import newsSlice from './news/newsSlice';
import menuSlice from './menu/menuSlice';

const cmsSlice = combineReducers({
    pages: pagesSlice,
    news: newsSlice,
    menu: menuSlice,
});

export default cmsSlice;
